import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 7 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 8\" id=\"icon-delete\"><path d=\"M5.893.667 3.499 3.06 1.106.667l-.94.94L2.559 4 .166 6.393l.94.94L3.499 4.94l2.394 2.393.94-.94L4.439 4l2.394-2.393z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol